<!--Feedback-->
<ng-container *ngIf="appShellService.showFeedbackButton">
    <span class="feedback-container" (click)="onFeedbackClick()">
        <mat-icon class="icon">chat_bubble_outline</mat-icon>
        <span class="text">{{ 'feedback' | transMigrated | async}}</span>
    </span>
</ng-container>